module.exports = __webpack_public_path__ + "static/media/icons-maps-pin.d948b70c.svg";